module.exports = __webpack_public_path__ + "img/embed-code.046cd2da.svg";